interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Exact search-icon asset from the Dashboard header Figma frame (76184:5977). */
const FigmaSearchIcon = ({ width = 16, height = 16, color = '#8B5CF6' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 15.9986 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.7067 14.2968L12.6099 11.1987C14.9271 8.10222 14.2953 3.71356 11.1987 1.39641C8.10222 -0.920736 3.71356 -0.288925 1.39641 2.80759C-0.920736 5.90411 -0.288925 10.2928 2.80759 12.6099C5.29497 14.4712 8.71133 14.4712 11.1987 12.6099L14.2968 15.708C14.6861 16.0973 15.3174 16.0973 15.7067 15.708C16.096 15.3187 16.096 14.6874 15.7067 14.2982L15.7067 14.2968ZM7.02898 12.012C4.27695 12.012 2.04601 9.78102 2.04601 7.02898C2.04601 4.27695 4.27695 2.04601 7.02898 2.04601C9.78102 2.04601 12.012 4.27695 12.012 7.02898C12.009 9.77977 9.7798 12.009 7.02898 12.012Z'
        fill={color}
      />
    </svg>
  );
};

export default FigmaSearchIcon;
